import { Button, Checkbox } from "antd";
import { useEffect, useState } from "react";
import arrowLeft from "./../../assets/images/arrow-left.svg";
import "./ReferCarePlan.css";
import ProgressIndicator from "../../commonComponents/ProgressIndicator";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchMedicalConditions } from "./service";

const PatientCondition = () => {
  const navigate = useNavigate();
  const state = useLocation()?.state;
  const [patientCondition, setPatientCondition] = useState<any>(
    state?.patientCondition || {}
  );
  const [activeCondition, setActiveCondition] = useState<number | null>(null);
  const [medicalConditions, setMedicalConditions] = useState([]);

  useEffect(() => {
    getMedicalConditions();
  }, []);

  const getMedicalConditions = async () => {
    const res: any = await fetchMedicalConditions();
    setMedicalConditions(res?.data);
  };

  const handleConditionClick = (condition: any) => {
    setPatientCondition({
      medical_condition_group_id: condition?.medical_condition_group_id,
      medical_condition_name: condition?.meta_data?.alias,
    });
  };

  const checkboxHandler = (condition: any, index: number) => {
    setActiveCondition(index);
    handleConditionClick(condition);
  };

  const backBtnHandler = () => {
    navigate(-1);
  };

  const continueBtnHandler = () => {
    navigate("/patient-care-program", {
      state: {
        ...state,
        patientCondition: patientCondition,
      },
    });
  };

  return (
    <div className="p-6">
      <div className="w-full fixed top-0 left-0 z-10">
        <div className="p-6 bg-white mx-auto max-w-[1280px]">
          <div className="flex items-start font-semibold gap-x-2 pb-5">
            <img
              height={22}
              width={22}
              src={arrowLeft}
              alt="arrow-left"
              onClick={backBtnHandler}
            />
            <span>Refer care plan</span>
          </div>
          <ProgressIndicator currentStep={1} totalSteps={4} />
        </div>
      </div>

      <div className="mt-24 flex flex-start flex-col">
        <span className="font-semibold text-2xl text-left pb-5">
          Select Patient's Condition
        </span>
        <div className="flex flex-col gap-y-4 pb-16">
          {medicalConditions?.map((c: any, index: number) => (
            <div
              key={index}
              className={`p-4 border ${activeCondition === index
                ? "border-[#4B4AD5] bg-[#4b4ad51a]"
                : "border-[#DCE4E8]"
                } rounded-2xl flex gap-x-2 items-baseline w-[calc(50%-1rem)] justify-between h-24 cursor-pointer`}
              style={{ width: "100%" }}
              onClick={() => checkboxHandler(c, index)}
            >
              <div className="flex flex-col items-start">
                <div
                  className={`font-semibold ${activeCondition === index
                    ? "text-[#1F2933]"
                    : "text-[#5A6774]"
                    }`}
                >
                  {c?.meta_data?.alias}
                </div>
                <span
                  className={`text-sm font-medium text-left  ${activeCondition === index
                    ? "text-[#3D4854]"
                    : "text-[#5a6774]/60"
                    }`}
                >
                  {c?.meta_data?.subtitle}
                </span>
              </div>
              <Checkbox
                className="custom-check-box"
                checked={
                  patientCondition?.medical_condition_group_id ===
                  c?.medical_condition_group_id
                }
              />
            </div>
          ))}
        </div>
      </div>
      {patientCondition?.medical_condition_group_id ? (
        <div className="w-full fixed bottom-0 left-0 z-1">
          <div className="mx-auto max-w-[1280px] w-full p-6">
            <Button
              type="primary"
              className="w-full h-14 rounded-2xl bg-[#4B4AD5] p-5 text-lg font-medium"
              onClick={continueBtnHandler}
              disabled={!patientCondition?.medical_condition_group_id}
            >
              Continue
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default PatientCondition;
